import { createContext, useContext, useState, useCallback, useMemo } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [walletApiKey, setWalletApiKeyState] = useState(
        () => sessionStorage.getItem('walletApiKey') || ''
    );
    const [userId, setUserIdState] = useState(
        () => sessionStorage.getItem('userId') || ''
    );
    const [isAdmin, setIsAdmin] = useState(
        () => sessionStorage.getItem('isAdmin') === 'true'
    );
    const [userName, setUserName] = useState(
        () => sessionStorage.getItem('userName') || ''
    );

    const setWalletApiKey = useCallback((key) => {
        sessionStorage.setItem('walletApiKey', key);
        setWalletApiKeyState(key);
    }, []);

    const setUserId = useCallback((id) => {
        sessionStorage.setItem('userId', String(id));
        setUserIdState(String(id));
    }, []);

    const setAdminMode = useCallback((val) => {
        sessionStorage.setItem('isAdmin', String(val));
        setIsAdmin(val);
    }, []);

    const setUserNameValue = useCallback((name) => {
        sessionStorage.setItem('userName', name);
        setUserName(name);
    }, []);

    const isAuthenticated = !!walletApiKey && !!userId;

    const logout = useCallback(() => {
        sessionStorage.removeItem('walletApiKey');
        sessionStorage.removeItem('userId');
        sessionStorage.removeItem('isAdmin');
        sessionStorage.removeItem('userName');
        setWalletApiKeyState('');
        setUserIdState('');
        setIsAdmin(false);
        setUserName('');
    }, []);

    const value = useMemo(
        () => ({
            walletApiKey,
            userId,
            isAdmin,
            userName,
            isAuthenticated,
            setWalletApiKey,
            setUserId,
            setAdminMode,
            setUserName: setUserNameValue,
            logout,
        }),
        [walletApiKey, userId, isAdmin, userName, isAuthenticated, setWalletApiKey, setUserId, setAdminMode, setUserNameValue, logout]
    );

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error('useAuth must be used within AuthProvider');
    return ctx;
};

export default AuthContext;
